export const CLEAR_DATA = "CLEAR_DATA";

export const CHANGE_SUBCATEGORY_SELECTED_SUCCESS =
  "CHANGE_DASHBOARD_SUBCATEGORY_SELECTED_SUCCESS";
